import type { LosslessNumber } from 'lossless-json';
import type {
    CloverTransactionStatusRequestDetails,
    CloverTransactionStatusResponseDetails,
} from './clover-transaction-status.types';

export const CloverReconciliationLookupOutcome = {
    AVAILABLE: 'available',
    UNAVAILABLE: 'unavailable',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CloverReconciliationLookupOutcome =
    (typeof CloverReconciliationLookupOutcome)[keyof typeof CloverReconciliationLookupOutcome];

export interface CloverReconciliationLookupRequest {
    readonly merchant_transaction_id: string;
    readonly settlement_date?: string;
}

export interface CloverReconciliationLookupRequestDetails {
    readonly statusRequestDetails: CloverTransactionStatusRequestDetails;
    readonly lookup: CloverReconciliationLookupRequest;
}

export interface CloverReconciliationLookupResult {
    readonly gateway_txn_id: string;
    readonly merchant_transaction_id: string;
    readonly is_settled: boolean;
    readonly batched_amount?: LosslessNumber;
    readonly gateway_batch?: string;
    readonly settlement_status?: string;
    readonly authorization_code?: string;
}

export type CloverReconciliationLookupResponseDetails =
    | {
          readonly outcome: typeof CloverReconciliationLookupOutcome.AVAILABLE;
          readonly httpStatus: 200;
          readonly transactionStatusResponseDetails: CloverTransactionStatusResponseDetails;
          readonly normalizedResult: CloverReconciliationLookupResult;
      }
    | {
          readonly outcome: typeof CloverReconciliationLookupOutcome.UNAVAILABLE;
          readonly httpStatus: number;
          readonly transactionStatusResponseDetails: CloverTransactionStatusResponseDetails;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CloverReconciliationLookupOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly transactionStatusResponseDetails: CloverTransactionStatusResponseDetails;
          readonly message: string;
      };
